import type { AgreementType } from '@portal/flows/domain/sa/types';

/**
 * `?type=` on the service-agreement pages (price list, customers, orders): which agreement type
 * the page opens on, so the sidebar and the legacy per-type addresses can deep-link
 * (LEGACY_PARITY_RUNS.md P4). Anything else is dropped rather than refused.
 */
export interface AgreementTypeSearch<T extends AgreementType = AgreementType> {
  type?: T;
}

/**
 * Call from the route's own annotated `validateSearch`: TanStack Router infers the search type
 * from that function's signature, and loses it when the validator is a returned closure.
 */
export function parseAgreementType<T extends AgreementType>(
  search: Record<string, unknown>,
  allowed: readonly T[],
): AgreementTypeSearch<T> {
  return allowed.includes(search['type'] as T) ? { type: search['type'] as T } : {};
}
